(function($){

    function initMap( $el ) {

        // Find marker elements within map.
        var $markers = $el.data('markers');
        var $map = $el.data('map');
        var map = new google.maps.Map( $el[0], $map );

        // Add markers.
        map.markers = [];
        if(Array.isArray($markers)) {
            $markers.forEach((marker, index) => {
                initMarker( marker, map );
            })
        }

        // Center map based on markers.
        centerMap( map );
        // Return map instance.
        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {

        // Get position from marker.
        var lat = $marker['position']['lat'];
        var lng = $marker['position']['lng'];
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };

        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            icon: $marker['icon'],
            scaledSize: 'shrink'
        });
        google.maps.event.addListener(marker, 'mouseover', function() {
            marker.setIcon($marker['iconHover']);
        });
        google.maps.event.addListener(marker, 'mouseout', function() {
            marker.setIcon($marker['icon']);
        });

        if ($marker['url']) {
            if ($("#"+$marker['url']).length){
                marker.addListener('click', function () {
                    $('html, body').animate({
                        Easing: 'swing',
                        scrollTop: $("#"+$marker['url']).offset().top - 150
                    }, 400);
                    setTimeout(function() {
                        $('.stores__card').removeClass('stores__card_active');
                        $("#"+$marker['url']).addClass('stores__card_active');
                    }, 300);
                });
            } else {
                marker.addListener('click', function () {
                    let markerUrl = "https://www.google.com/maps/search/?api=1&query=" + $marker['position']['lat'] + "%2C" + $marker['position']['lng'] + "&query_place_id=" + $marker['url'];
                    window.open(markerUrl, '_blank');
                });
            }

        }

        // Append to reference for later use.
        map.markers.push( marker );

    }

    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
            // bounds.extend({lat: 48.55722306655722, lng: 14.3416341909032});
            // bounds.extend({lat: 51.014431467797124, lng: 15.026654935862737});
        });

        // Don't zoom in too far on only one marker
        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );
            // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }

    // Render maps on page load.
    $(document).ready(function(){
        $('.stores_map').each(function(){
            var map = initMap( $(this) );
        });
    });

})(jQuery);
